import { Box } from '@chakra-ui/react'
import AboutUsForm from './components/AboutUsForm'

export default function User () {
  return (
    <Box pt={{ base: '130px', md: '80px', xl: '80px' }}>
      <AboutUsForm />
    </Box>
  )
}
